import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

export const ResetConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  content
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title || 'Confirm Reset'}</DialogTitle>
      <DialogContent>
        {content || 'Are you sure you want to reset?'}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="warning">Yes, Reset</Button>
      </DialogActions>
    </Dialog>
  );
};
